import { combineReducers } from 'redux';
import * as fromBreadCrumbs from './BreadCrumbs/Reducer';
import * as fromSecurity from './Security/Reducer';

export interface IRootState {
  breadCrumbsState: fromBreadCrumbs.IBreadCrumbsState;
  securityState: fromSecurity.ISecurityState;
}

export const rootInitialState: IRootState = {
  breadCrumbsState: fromBreadCrumbs.initialState,
  securityState: fromSecurity.initialState
};

export const rootReducer = combineReducers<IRootState>({
  breadCrumbsState: fromBreadCrumbs.reducer,
  securityState: fromSecurity.reducer
});
